module.exports = __webpack_public_path__ + "img/frame16_normal.6dd8b7e0.png";